export default "__VITE_ASSET__yXftD8C2__"